import _get from 'lodash/get';

interface LubricantTypeListItem {
  id: string | number;
  name: string;
  remarks: string | null;
}

interface ApiResponse {
  success: boolean;
  message: string;
  data: {
    content: LubricantTypeListItem[];
  };
  timestamp: string;
  errors: any;
  requestId: string;
}

interface LubricantTypesApiParser {
  LubricantTypesListParser: (_res: ApiResponse) => LubricantTypeListItem[];
}

const lubricantTypesApiParser: LubricantTypesApiParser = {
  LubricantTypesListParser: (_res: ApiResponse) => {
    // Parse the API response
    const content = _get(_res, 'data.content', []);

    // Transform the data to match our interface
    const data: LubricantTypeListItem[] = content.map((item: any) => ({
      id: _get(item, 'id', 0),
      name: _get(item, 'name', ''),
      remarks: _get(item, 'remarks', null),
    }));

    return data;
  },
};

export default lubricantTypesApiParser;

// --------------- Type-specific types and data ---------------

export interface LubricantTypeItem {
  id: number;
  typeName: string;
  remarks: string;
}

export interface LubricantTypesData {
  types: LubricantTypeItem[];
}
